export default __webpack_public_path__ + "static/media/AlertIcons.2b88d7c4.svg";